<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Produit de la Caisse Nationale d'Epargne" />
            <CaisseNational />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import CaisseNational from '../Services/CaisseNational'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'CaisseNationalPage',
    components: {
        NavBar,
        PageTitle,
        CaisseNational,
        FooterComp,
    }
}
</script>